import { Component, Input, OnInit, input, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PriceType } from '@shared/pipes/price-format.pipe';
import { IconNames } from '@shared/enums/icon-names';
import { imageAssets } from '@core/constants/themes';
import { ThemeService } from '@core/services/theme.service';
import { Theme } from '@support/models/theme.model';
import { HardwareVariant } from '@app/sales/modules/mobilephone/models/mobilephone-variant';
import { AppData } from '@app/shared/models/appdata.model';
import { buildWebShopLink } from '@app/core/utils';
import { AsyncPipe, NgClass } from '@angular/common';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { SimTypeSupport } from '@app/sales/modules/mobilephone/models/sim-type-support';
import { IceImgPillComponent } from '@app/shared/components/atoms/ice-img-pill/ice-img-pill.component';

@Component({
  selector: 'app-mobilephone-info',
  templateUrl: './mobilephone-info.component.html',
  styleUrls: ['./mobilephone-info.component.scss'],
  imports: [SpinnerComponent, AsyncPipe, NgClass, IceImgPillComponent],
})
export class MobilephoneInfoComponent implements OnInit {
  themeService = inject(ThemeService);
  private appData = inject(AppData);

  IconNames = IconNames;
  PriceType = PriceType;
  SimTypeSupport = SimTypeSupport;
  imageAssets = imageAssets;

  @Input() phoneName: string;
  @Input() mobilePhoneVariant: HardwareVariant;
  @Input() isManualRegistration: boolean;
  @Input() isLoadingMobilePhoneOffering: boolean;

  isMinified = input<boolean>(false);

  selectedTheme$: Observable<Theme>;

  ngOnInit() {
    this.selectedTheme$ = this.themeService.selectedTheme;
  }

  get webShopLink(): string {
    const slug = this.mobilePhoneVariant?.groupSlug || '';
    const manufacturer = this.mobilePhoneVariant?.manufacturer || '';

    return buildWebShopLink(this.appData.webShopBaseUrl, slug, manufacturer);
  }
}
